import React, { useEffect, useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import ConfirmationModel from "../../Components/Common/Model/Model";
import { Divider, Grid, Pagination, Typography,Radio,Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { DcoiActions, GetPolicyByHFMCodeAndLanguageId, GetUserDetailByUPN, Getsumission, SubmitForm, UserFormData, saveUnblockRequest } from "../../Reducers/dcoi";
import { postGetFormLabelByUserName, GetSubmissionsByUsername, GetDefaulFormLabelByUserName } from "../../Reducers/dcoi";
import Spinner from "../../Components/Common/Spinner/Spinner"
import './Dashboard.css';
import { Box } from "@mui/material";
import InfoICon from "../../images/icons/info.svg"
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import Modal from "../../Components/Modal/Modal";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckBoxControl from "../../Components/Common/CheckBox/CheckBox";
import { styled } from "@mui/material/styles";
import Toster from "../../Components/Common/Toster/Toster";

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 30,
  height: 30,
  borderRadius: "50%",
  backgroundColor:
  ownerState.active || ownerState.completed ? "#212129" : "#666666",
  color: "#fff",
  fontWeight: "bold",
  fontSize: "18px",
}));

const Dashboard = () => {
  const dispatch = useDispatch();
  const { PolicyDataNew, userformDataList, languageDropdown, languageData, inProgress, userDetails } = useSelector(
    (state) => state.dcoi
  );
  const [isConfirmed,setIsConfirmed]=useState(false);
  const [isModalOpenSubmit, setIsModalOpenSubmit] = React.useState(false);
  const [rows, setRows] = useState([{ id: 1, Company: "", Details: "" }]);
  const [rows1, setRows1] = useState([{ id: 1, Organization: "", Role: "", EndDate: "" }]);
  const [steps, setSteps] = useState([]);
  const [message, setMessage] = useState();
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isStapperOpen, setIsStapperOpen] = useState(false);
  const [languageID,setLanguageID]=useState();

  useEffect(() => {
    if (userDetails?.SpecialGroup && userformDataList.length > 0) {
      dispatch(UserFormData({ SubmissionId: userformDataList[0]?.Id })).then((res) => {
        if (res.payload?.status === 200) {
          setRows(Array.isArray(res.payload.data?.Table) && res.payload.data?.Table.length
            ? res.payload.data.Table.map((item, index) => ({
              id: index,
              Company: item.Company,
              Details: item.Details
            }))
            : [{
              id: 1,
              Company: "",
              Details: ""
            }] // Return an empty array if Table is not an array
          );

          setRows1(Array.isArray(res.payload.data?.Table1) && res.payload.data?.Table1.length
            ? res.payload.data.Table1.map((item, index) => ({
              id: index,
              Organization: item.Organization,
              Role: item.Role,
              EndDate: item.EndDate
            }))
            : [{
              id: 1,
              Organization: "",
              Role: "",
              EndDate: "",
            }] // Return an empty array if Table1 is not an array
          );
        }
      });
    }
    setSteps([
      {
        label: languageData.Key2,
        description: languageData.Key40,
        name: languageData.Key3,
        jobTitle: languageData.Key4,
        aggrement: languageData.Key7,
        isChecked: false,
        isRequired: true,
      },
      {
        label: languageData.Key9,
        description: PolicyDataNew?.Content || "",
        aggrement: languageData.Key10,
        isChecked: false,
        isRequired: true,
      },
      {
        label: languageData.Key11,
        radioText1: languageData.Key12,
        radioText2: languageData.Key13,
        description: languageData.Key14,
        header1: languageData.key15,
        header2: languageData.key16,
        extraDescription: languageData.Key19,
      },
      {
        label: languageData.Key38,
        description: PolicyDataNew?.AFAContent || "",
        isChecked: false,
        isRequired: true,
        aggrement: languageData.Key31,
      },
      {
        label: languageData.Key30,
        radioText1: languageData.Key32,
        radioText2: languageData.Key33,
        description: languageData.Key34,
        header3: languageData.Key35,
        header4: languageData.Key36,
        header5: languageData.Key37,
      },
      {
        label: languageData.Key20,
        aggrement: languageData.Key21,
        isChecked: false,
        isRequired: true,
      },
    ]);
  }, [languageData, userformDataList,PolicyDataNew]);

  useEffect(() => {
    if (userDetails?.SpecialGroup && userformDataList.length > 0) {
      const preloadedStepValues = {
        0: { checkbox: true, employeeName: userDetails?.Name, jobTitle: userDetails?.JobTitle },
        1: { checkbox: true },
        2: { radio: userformDataList[0]?.HaveConfictOfInterest ? "option2" : "option1" },
        3: { checkbox: true, PolicyID: userformDataList[0]?.DcoICycleId },
        4: { radio: userformDataList[0]?.HavePEP ? "option2" : "option1" },
        5: { checkbox: true },
      };
      setStepValues(preloadedStepValues);
      setSteps((prevSteps) =>
        prevSteps.map((step) => ({
          ...step,
          isChecked: true,
        }))
      );
    }else{
      const preloadedStepValues = {
        0: { checkbox: false, employeeName: userDetails?.Name, jobTitle: userDetails?.JobTitle },
        1: { checkbox: false },
        2: { radio:"option1" },
        3: { checkbox: false, PolicyID: userformDataList[0]?.DcoICycleId },
        4: { radio:"option1" },
        5: { checkbox: false },
      };
      setStepValues(preloadedStepValues);
      setSteps((prevSteps) =>
        prevSteps.map((step) => ({
          ...step,
          isChecked: false,
        }))
      );
      setActiveStep(0);
    }
  }, [userDetails?.SpecialGroup,languageData,userformDataList,PolicyDataNew]);

  useEffect(() => {
    dispatch(DcoiActions.activeDisplay({ menu: languageData?.Key_MasterPage_7, subMenu: languageData?.Key_MasterPage_7 }))
  }, [isStapperOpen])

  useEffect(()=>{
      dispatch(DcoiActions.activeDisplay({
      menu: "My Submission",
      subMenu: languageData?.Key_MasterPage_6
    }))
  },[isConfirmed])

  const handleAddRow = () => {
    const newRow = { id: rows.length + 1, Company: "", Details: "" };
    const updatedRows = [...rows, newRow];
    setRows(updatedRows);

    setStepValues((prevValues) => ({
      ...prevValues,
      2: { ...prevValues[2], ROWSDATA: updatedRows },
    }));
  };

  const handleDeleteRow = (id) => {
    const updatedRows = rows.filter((row) => row.id !== id);
    setRows(updatedRows);

    setStepValues((prevValues) => ({
      ...prevValues,
      2: { ...prevValues[2], ROWSDATA: updatedRows },
    }));
  };

  const handleAddRow1 = () => {
    const newRow = { id: rows1.length + 1, Organization: "", Role: "", EndDate: "" };
    const updatedRows1 = [...rows1, newRow];
    setRows1(updatedRows1);

    setStepValues((prevValues) => ({
      ...prevValues,
      4: { ...prevValues[4], ROWSDATA1: updatedRows1 },
    }));
  };

  const handleDeleteRow1 = (id) => {
    const updatedRows1 = rows1.filter((row) => row.id !== id);
    setRows1(updatedRows1);

    setStepValues((prevValues) => ({
      ...prevValues,
      4: { ...prevValues[4], ROWSDATA1: updatedRows1 },
    }));
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const [stepValues, setStepValues] = React.useState({
    0: { checkbox: false, employeeName: userDetails.Name, jobTitle: userDetails.JobTitle },
    1: { checkbox: false },
    2: { radio: "option1", ROWSDATA: [] },
    3: { PolicyID: PolicyDataNew?.PolicyID },
    4: { radio: "option1", ROWSDATA1: [] },
    5: { checkbox: false },
  });

  const handleCheckboxChange = (index) => {
    setStepValues((prevValues) => {
      const updatedStepValues = { ...prevValues };
      updatedStepValues[index].checkbox = !updatedStepValues[index].checkbox;

      return updatedStepValues;
    });

    setSteps((prevSteps) =>
      prevSteps.map((step, i) =>
        i === index ? { ...step, isChecked: !step.isChecked } : step
      )
    );
  };


  const handleRadioChange = (index, value) => {
    setStepValues((prevValues) => ({
      ...prevValues,
      [index]: { ...prevValues[index], radio: value },
    }));
  };

  const handleNext = async () => {
    const currentStepData = stepValues[activeStep];

    try {
      let ROWSDATA = currentStepData.ROWSDATA || []; // Preserve existing data if any
      let ROWSDATA1 = currentStepData.ROWSDATA1 || []; // Preserve existing data if any

      if (activeStep === 2 && currentStepData.radio === "option2") {
        ROWSDATA = rows.map((row) => ({
          Company: row.Company,
          Details: row.Details,
        }));
      }

      if (activeStep === 4 && currentStepData.radio === "option2") {
        ROWSDATA1 = rows1.map((row) => ({
          Organization: row.Organization,
          Role: row.Role,
          EndDate: row.EndDate,
        }));
      }

      setStepValues((prevValues) => ({
        ...prevValues,
        [activeStep]: {
          ...prevValues[activeStep], // Preserve existing values
          ROWSDATA, // Update ROWSDATA if applicable
          ROWSDATA1, // Update ROWSDATA1 if applicable
        },
      }));

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } catch (error) {
      console.error("Error saving step data:", error);
    }
  };


  const handleSubmit = async (stepValue) => {
    const result = {
      DCI_UserEmail: userDetails.UserName,
      DCI_Content_PolicyId: PolicyDataNew?.PolicyID,
      DCI_IsHaveConfictOfInterest: 0,
      DCI_HavePEP: 0,
      DCI_ConfictOfInterests: [],
      DCI_PEP: []
    };
    Object.values(stepValue).forEach(item => {
      if (item.radio === "option2" && item.ROWSDATA?.length) {
        item.ROWSDATA.forEach(row => {
          if (row.Company && row.Details) {
            result.DCI_IsHaveConfictOfInterest = 1;
            result.DCI_ConfictOfInterests.push({
              CompanyOrMarket: row.Company,
              DetailConflictOfInterest: row.Details
            });
          }
        });
      };

      if (item.radio === "option2" && item.ROWSDATA1?.length) {
        item.ROWSDATA1.forEach(row => {
          if (row.Organization && row.Role && row.EndDate) {
            result.DCI_HavePEP = 1;
            result.DCI_PEP.push({
              NameOfOrganization: row.Organization,
              Role: row.Role,
              DateOfEmployment: row.EndDate
            });
          }
        });
      }

    });
    dispatch(SubmitForm({ result })).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setActiveStep(0);
        setIsModalOpenSubmit(true); // Update state to show the modal
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success");
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.error)
        setSeverity("error");
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    });
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepValid = () => {
    const currentStep = steps[activeStep];
    const currentValues = stepValues[activeStep];

    // Ensure the current step and its values exist
    if (!currentStep || !currentValues) {
      return false;
    }

    // Check if the step requires the checkbox and it's not checked
    if (currentStep.isRequired && !currentValues.checkbox) {
      return false; // Checkbox must be checked
    }

    // If 'option1' is selected, skip validation
    if (currentValues.radio === "option1") {
      return true;
    }

    // Validate dynamic rows for Step 3 and Step 5
    if (activeStep === 2 || activeStep === 4) {
      const rowsToCheck = activeStep === 2 ? rows : rows1;

      if (!rowsToCheck || rowsToCheck.length === 0) {
        return false; // Rows must exist
      }

      const hasEmptyInput = rowsToCheck.some((row) => {
        // Null-safe checks for each required field
        const isStep2Invalid =
          activeStep === 2 &&
          (!row.Company?.trim() || !row.Details?.trim());

        const isStep4Invalid =
          activeStep === 4 &&
          (!row.Organization?.trim() ||
            !row.Role?.trim() ||
            !row.EndDate?.trim());

        return isStep2Invalid || isStep4Invalid;
      });

      if (hasEmptyInput) {
        return false; // Disable "Next" button if any input is invalid
      }
      if (activeStep === 4) {
        const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/; // DD-MM-YYYY format

        const hasInvalidDate = rowsToCheck.some(row => !dateRegex.test(row.EndDate));
        if (hasInvalidDate) {
          return false; // Disable "Next" if any date is invalid
        }
      }
    }

    return true; // If all conditions pass, allow "Next"
  };

  const handleRowInputChange = (id, field, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
    setStepValues((prevValues) => ({
      ...prevValues,
      2: { ...prevValues[2], ROWSDATA: updatedRows },
    }));
  };

  const handleRow1InputChange = (id, field, value) => {
    const updatedRows1 = rows1.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows1(updatedRows1);
    setStepValues((prevValues) => ({
      ...prevValues,
      4: { ...prevValues[4], ROWSDATA1: updatedRows1 },
    }));
  };

  const closeModel = () => {
    setIsModalOpenSubmit(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      dispatch(GetDefaulFormLabelByUserName()).then(async (res) => {
        if (res.payload?.data[0]?.ID) {
          setLanguageID(res.payload?.data[0]?.ID)
          await Promise.all([
            dispatch(GetPolicyByHFMCodeAndLanguageId({ "languageID": res.payload?.data[0]?.ID })),
            dispatch(postGetFormLabelByUserName()),
            dispatch(GetSubmissionsByUsername()),
            dispatch(GetUserDetailByUPN()),
          ]);
        }
      })

    }
    fetchData();
  }, []);


  useEffect(() => {
    dispatch(DcoiActions.activeDisplay({ menu: languageData?.Key_MasterPage_5, subMenu: languageData?.Key_MasterPage_5 }))
  }, [languageData])


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userformDataList.slice(indexOfFirstItem, indexOfLastItem);


  const handleButtonClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleModelAction = () => {
    setModalOpen(false);
    setIsStapperOpen(true);
  };

  const ChangeLanguage = (e) => {
    const selectedLanguage = e.target.value;
    dispatch(DcoiActions.setFormLabelsData({list:languageDropdown,id:selectedLanguage}));
    setLanguageID(selectedLanguage);
    dispatch(GetPolicyByHFMCodeAndLanguageId({ "languageID": selectedLanguage }));
  };

  const handlePdfDownload = async (value) => {
    try {
      const res = await dispatch(Getsumission({ PdfBlobUrl: value }));
  
      if (res.payload && res.payload.data) {
        const base64Data = res.payload.data.fileContent;
        if (!base64Data) {
          console.error("Invalid Base64 data.");
          return;
        }
  
        // Convert Base64 to binary
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(fileBlob);

        const newTab = window.open(fileURL, "_blank");
        if (!newTab) {
          alert("Please allow pop-ups to view the PDF.");
        }

        setTimeout(() => {
          URL.revokeObjectURL(fileURL);
        }, 60000); // Cleanup after 1 minute
        
      } else {
        console.error("Failed to retrieve the PDF file.");
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };
  

  const submitChange = () => {
    setIsConfirmed(true);
    dispatch(GetUserDetailByUPN());
    dispatch(GetSubmissionsByUsername());
    setIsStapperOpen(false);
  }

  const unblockHandler = () => {
    dispatch(saveUnblockRequest({}))
      .then((res) => {
        const payload = res?.payload;

        // Success response
        if (payload?.data?.Table?.[0]) {
          setAlert(true);
          setMessage(payload.data.Table[0].Message);
          setSeverity("success");
        }
        // Error response
        else if (payload?.data?.[0]?.status === "error") {
          setAlert(true);
          setMessage(payload.data[0].error || "Something Went Wrong");
          setSeverity("error");
        }
        // Unknown response
        else {
          setAlert(true);
          setMessage("Something Went Wrong");
          setSeverity("error");
        }
      })
      .catch((error) => {
        console.error("Unblock request failed:", error);

        setAlert(true);
        setMessage("Something Went Wrong");
        setSeverity("error");
      });
  };


  return (
    <>
        <Modal isOpen={isModalOpenSubmit} onClose={closeModel} children={languageData} submitChange={submitChange} />
        <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <Box sx={{ margin: "0px 40px 10px", display: "flex", justifyContent: { xs: "left", sm: "right" }, position: "relative", right: "0px", top: { xs: "0px", sm: "-40px" } }}>
        <select
          value={languageID}
          onChange={ChangeLanguage}
          className="customSelectDashboard"
        >
          {languageDropdown.map((lang) => (
            <option key={lang.ID} value={lang.ID}>
              {lang.Language}
            </option>
          ))}
        </select>
      </Box>

      {isStapperOpen ? (
        ""
      ) : (<>
        <Grid
          container
          spacing={2}
          sx={{
            backgroundColor: "#E7E7E7",
            margin: "0px 40px",
            width: "auto",
            padding: "10px 20px",
            display: "flex",
            justifyContent: "space-between"
          }}
          alignItems="center" // Ensures vertical alignment of text and button
        >
          {/* Text Section */}
          <Grid
            sx={{
              fontSize: "12px",
              display: "flex",
              padding: "10px",
              alignItems: "center"
            }}
          >
            <img src={InfoICon} alt="info" />&nbsp;&nbsp;<Typography sx={{ paddingLeft: "10px" }}>{userDetails.UserStatus?.toUpperCase() === "SUBMITTED" && userDetails.SpecialGroup ? languageData?.Key_E_Banner : languageData?.Key_MySubmission_1}</Typography>
          </Grid>
          {/* Button Section */}
          <Grid
            sx={{
              display: `${userDetails.UserStatus?.toUpperCase() === "SUBMITTED" && userDetails.SpecialGroup === null ? "none" : "flex"}`,
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <button className="submit-btn" onClick={handleButtonClick}>
              {userDetails.UserStatus?.toUpperCase() === "SUBMITTED" && userDetails.SpecialGroup ? languageData?.Key_E_Button : languageData?.Key_MySubmission_3}
            </button>
          </Grid>
        </Grid>
      </>
      )}

      {!isStapperOpen && (
        <>
        <Grid container spacing={2} alignItems="center" sx={{ padding: "20px 40px", }} >
           {/* Submission Title */} 
           <Grid item xs={12} sm={6} sx={{ fontSize: "16px", fontWeight: 500, }} > 
            {languageData.Key_MySubmission_4} 
            </Grid> {/* Unblock + Status */} 
            <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-end" }, alignItems: "center", gap: "20px", }} >
               {userDetails.UserStatus?.toUpperCase() === "SUBMITTED" && ( <button type="button" className="submit-btn" onClick={unblockHandler}> Unblock </button> )}
                <Typography sx={{ fontWeight: 600, color: "#5A80B7", whiteSpace: "nowrap", }} > {languageData.Key_MySubmission_5?.toUpperCase()} :{" "} {userDetails.UserStatus?.toUpperCase()} </Typography> 
            </Grid>
          </Grid>
          <Box sx={{ margin: "10px 40px", overflowX: "auto" }}>
            <Box sx={{ minWidth: "700px" }}>
              <Box>
                <Grid
                  container
                  alignItems="center"
                  spacing={2}
                  sx={{

                    padding: "12px 10px",
                    backgroundColor: "#f1f1f1",
                    borderBottom: "2px solid lightgray",
                    textAlign: "left",
                    color: "#4D4D4D",
                    marginBottom: "10px",
                  }}
                >
                  <Grid item xs={1} sm={1} md={1}>
                    <Typography sx={{ fontWeight: 600 }}>{languageData.Key_MySubmission_9}</Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <Typography sx={{ fontWeight: 600 }}> {languageData.Key_MySubmission_10}</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography sx={{ fontWeight: 600 }}> {languageData.Key_MySubmission_11}</Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <Typography sx={{ fontWeight: 600 }}>{languageData.Key_MySubmission_12}</Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <Typography sx={{ fontWeight: 600 }}>{languageData.Key_MySubmission_13}</Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>

                  </Grid>
                </Grid>
              </Box>
              {Array.isArray(currentItems) && currentItems.length > 0 ? (
                currentItems?.map((item, index) => (

                  <Box key={index}>


                    <Grid
                      container
                      alignItems="center"
                      spacing={2}
                      sx={{
                        fontWeight: "bold",
                        padding: "12px 10px",
                        textAlign: "left",
                        flexWrap: "nowrap",  // Prevents wrapping
                      }}
                    >
                      {/* Year */}
                      <Grid item xs={1} sm={1} md={1}>
                        <Typography>{item.year}</Typography>
                      </Grid>
                      {/* Location */}
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>{item.Location}</Typography>
                      </Grid>
                      {/* Job Title */}
                      <Grid item xs={3} sm={3} md={3}>
                        <Typography>{item.JobTitle}</Typography>
                      </Grid>
                      {/* HFM Code */}
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>{item.HFMCode}</Typography>
                      </Grid>
                      {/* Signoff Date */}
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>
                          {new Date(item.signoff).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </Typography>
                      </Grid>
                      {/* View PDF */}
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        sx={{
                          display: { xs: "none", sm: "none", md: "flex" },
                          alignItems: "center",
                          color: "#9D833E",
                          cursor: "pointer",
                        }}
                        onClick={() => handlePdfDownload(item.PdfBlobUrl)}
                      >
                        <Typography
                          sx={{
                            backgroundColor: "#e6e6e6",
                            fontWeight: 500,
                            padding: "4px 10px",
                            borderRadius: "10px",
                            color: "#212129",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          {languageData.Key26}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        sx={{
                          display: { xs: "flex", sm: "flex", md: "none" },
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => handlePdfDownload(item.PdfBlobUrl)}
                      >
                        <VisibilityIcon />
                      </Grid>
                    </Grid>
                    <Divider />

                  </Box>
                ))
              ) : (
                <>
                  {!inProgress && userformDataList?.length > 0 && currentItems?.length === 0 && (
                    <Typography
                      sx={{
                        margin: "20px",
                        textAlign: "center",
                        color: "gray",
                        fontStyle: "italic"
                      }}
                    >
                      {languageData?.Key_MySubmission_16}
                    </Typography>
                  )}
                  <Divider sx={{ margin: "0px 20px", padding: "0.5px 0px", background: "lightgray" }} />
                </>
              )}

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                {userformDataList?.length > 0 ? <Pagination showFirstButton showLastButton sx={{
                  margin: "10px", padding: "5px", border: "1px solid #212129",
                  borderRadius: "20px"
                }} count={Math.ceil(userformDataList.length / itemsPerPage)} page={currentPage} onChange={handlePageChange} /> : ""}

              </Box>
            </Box>
          </Box>
        </>
      )}

      <ConfirmationModel
        open={isModalOpen}
        handleOpen={handleCloseModal}
        data={PolicyDataNew}
        handleModelAction={handleModelAction}
        languageData={languageData}
      />

{isStapperOpen && (
  <Box sx={{ margin: "0px 40px" }}>
    <Typography sx={{ fontSize: "14px", padding: "20px 0px" }}>
      {languageData.Key1}
    </Typography>
    <Divider />
    <Box p={2}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              StepIconComponent={(props) => (
                <CustomStepIcon {...props} ownerState={{ active: props.active, completed: props.completed }}>
                  {index + 1} {/* Displaying the step number */}
                </CustomStepIcon>
              )}
            >
              <span className="customSpan">{step.label}</span>
            </StepLabel>
            <StepContent>
              {step.radioText1 && (
                <Box sx={{ backgroundColor: "#f2f2f2", margin: "17px", padding: "0px 4px" }}>
                  <Typography>
                    <label>
                      <Radio
                        checked={stepValues[index].radio === "option1"}
                        onChange={() => handleRadioChange(index, "option1")}
                      />
                      {step.radioText1}
                    </label>
                  </Typography>
                  <Typography>
                    <label>
                      <Radio
                        checked={stepValues[index].radio === "option2"}
                        onChange={() => handleRadioChange(index, "option2")}
                      />
                      {step.radioText2}
                    </label>
                  </Typography>
                </Box>
              )}
              {!step.radioText1 && <Typography sx={{ color: "#212129", fontSize: "12px" }} dangerouslySetInnerHTML={{ __html: step.description }}>
              </Typography>}

              {step.radioText1 && (<Grid container m={2} spacing={2} sx={{ backgroundColor: "#F2F2F2", width: "auto", textAlign: "left" }}>
                <Grid item xs={12} sm={12} p={2} sx={{ fontSize: "12px", fontWeight: "600" }}>
                  <Typography sx={{ color: "#212129", fontSize: "12px" }} dangerouslySetInnerHTML={{ __html: step.description }} >
                  </Typography>
                </Grid>
                {step.header1 && step.header2 ? (<>
                  {/* Headers */}
                  <Grid
                    container
                    spacing={{ xs: 2, sm: 2 }}
                    px={{ xs: 2, sm: 2 }}
                    sx={{
                      margin: "4px 0px",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={5}
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        display: { xs: "none", md: "flex" }
                      }}
                    >
                      {step.header1}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={5}
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        display: { xs: "none", md: "flex" }
                      }}
                    >
                      {step.header2}
                    </Grid>
                  </Grid>
                  {rows.map((row, index) => (
                    <Grid
                      container
                      key={row.id}
                      spacing={{ xs: 2, sm: 2 }}
                      px={{ xs: 2, sm: 2 }}
                      sx={{
                        margin: "4px 0",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={5}
                        sx={{
                          textAlign: "left",
                          fontWeight: "bold",
                          display: { xs: "flex", md: "none" }
                        }}
                      >
                        {step.header1}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={5}
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        <input
                          value={row.Company}
                          disabled={stepValues[2].radio !== "option2"}
                          onChange={(e) => handleRowInputChange(row.id, "Company", e.target.value)}
                          className="customInputStapper"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={5}
                        sx={{
                          textAlign: "left",
                          fontWeight: "bold",
                          display: { xs: "flex", md: "none" }
                        }}
                      >
                        {step.header2}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={5}
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        <input
                          value={row.Details}
                          disabled={stepValues[2].radio !== "option2"}
                          onChange={(e) => handleRowInputChange(row.id, "Details", e.target.value)}
                          className="customInputStapper"
                        />
                      </Grid>
                      {step.label === languageData.Key11 && index === 0 && (<Grid
                        item
                        xs={12}
                        sm={12}
                        md={2}
                        sx={{ display: "flex", alignItems: "center" }}
                      >                  <Typography
                        sx={{
                          padding: "10px",
                          color: stepValues[2].radio !== "option2" ? "grey" : "#212129",
                          fontSize: "12px",
                          fontWeight: "bolder",
                          cursor: stepValues[2].radio !== "option2" ? "not-allowed" : "pointer",
                          opacity: stepValues[2].radio !== "option2" ? 0.6 : 1,
                        }}
                        variant="contained"
                        onClick={() => {
                          if (stepValues[2].radio !== "option1") {  // Ensure it's only clickable when "option2" is selected
                            handleAddRow();
                          }
                        }}
                      >
                          {languageData.Key18} +
                        </Typography>
                      </Grid>)}
                      {index > 0 && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={1}
                          sx={{
                            textAlign: "center",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "center",
                          }}
                        >
                          <DeleteForeverIcon
                            sx={{
                              height: "34px",
                              color: "#8A732F",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDeleteRow(row.id)}
                          />
                        </Grid>
                      )}
                    </Grid>
                  ))}
                </>
                ) : (<>
                  <Grid
                    container
                    spacing={{ xs: 2, sm: 2 }}
                    px={{ xs: 2, sm: 2 }}
                    sx={{
                      margin: "4px 0",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={4}
                      sx={{
                        fontWeight: "bold",
                        display: { xs: "none", md: "flex" }
                      }}
                    >
                      {step.header3}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={3}
                      sx={{
                        fontWeight: "bold",
                        display: { xs: "none", md: "flex" }
                      }}
                    >
                      {step.header4}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={3}
                      sx={{
                        fontWeight: "bold",
                        display: { xs: "none", md: "flex" }
                      }}
                    >
                      {step.header5}
                    </Grid>
                  </Grid>
                  {rows1.map((row, index) => (
                    <Grid
                      container
                      key={row.id}
                      spacing={{ xs: 2, sm: 2 }}
                      px={{ xs: 2, sm: 2 }}
                      sx={{
                        margin: "4px 0",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        sx={{
                          fontWeight: "bold",
                          display: { xs: "flex", md: "none" }
                        }}
                      >
                        {step.header3}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                      >
                        <input
                          value={row.Organization}
                          disabled={stepValues[4].radio !== "option2"}
                          onChange={(e) => handleRow1InputChange(row.id, "Organization", e.target.value)}
                          className="customInputStapper"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={3}
                        sx={{
                          fontWeight: "bold",
                          display: { xs: "flex", md: "none" }
                        }}
                      >
                        {step.header4}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={3}
                      >
                        <input
                          value={row.Role}
                          disabled={stepValues[4].radio !== "option2"}
                          onChange={(e) => handleRow1InputChange(row.id, "Role", e.target.value)}
                          className="customInputStapper"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={3}
                        sx={{
                          fontWeight: "bold",
                          display: { xs: "flex", md: "none" }
                        }}
                      >
                        {step.header5}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={3}
                      >
                        <input
                          type="date"
                          value={row.EndDate ? row.EndDate.split("-").reverse().join("-") : ""}
                          disabled={stepValues[4].radio !== "option2"}
                          onChange={(e) => {
                            const value = e.target.value; // Keep it in YYYY-MM-DD for input compatibility
                            const formattedValue = value.split("-").reverse().join("-"); // Convert to DD-MM-YYYY
                            handleRow1InputChange(row.id, "EndDate", formattedValue);
                          }}
                          onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                          onPaste={(e) => e.preventDefault()} // Prevent pasting a value
                          className="customDateInput"
                        />



                      </Grid>
                      {step.label === languageData.Key30 && index === 0 && (<Grid
                        item
                        xs={12}
                        sm={12}
                        md={2}
                        sx={{ display: "flex", alignItems: "center" }}
                      >                  <Typography
                        sx={{
                          padding: "10px",
                          color: stepValues[4].radio !== "option2" ? "grey" : "#212129",
                          fontSize: "12px",
                          fontWeight: "bolder",
                          cursor: stepValues[4].radio !== "option2" ? "not-allowed" : "pointer",
                          opacity: stepValues[4].radio !== "option2" ? 0.6 : 1,
                        }}
                        variant="contained"
                        onClick={() => {
                          if (stepValues[4].radio !== "option1") {
                            handleAddRow1();
                          }
                        }}
                      >
                          {languageData.Key18} +
                        </Typography>
                      </Grid>)}
                      {index > 0 && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={1}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <DeleteForeverIcon
                            sx={{
                              height: "34px",
                              color: "#8A732F",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDeleteRow1(row.id)}
                          />
                        </Grid>
                      )}

                    </Grid>
                  ))}
                </>
                )}
              </Grid>)}
              {step.extraDescription && (
                <Grid
                  m={2}
                >
                  <Typography sx={{ color: "#7A7A7A" }}>{step.extraDescription}</Typography>
                </Grid>
              )}

              {step.name && step.jobTitle && (
                <Grid container spacing={2} alignItems="flex-start" sx={{ mt: 2 }}>
                  {(!userDetails.Name || !userDetails.JobTitle) && <Grid item xs={12} >
                    <Typography sx={{ padding: "10px 0px", color: "#7A7A7A",display:"flex",alignItems:"center",backgroundColor:"#E7E7E7",paddingX:2}}><WarningIcon/>&nbsp;&nbsp;{languageData.Key23}</Typography>
                  </Grid> }

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography
                      variant="caption"
                      display="block"
                      fontWeight={800}
                      fontSize={14}
                    >
                      {languageData.Key3} <span className="customSpanAlert">*</span>
                    </Typography>
                    <Typography sx={{ padding: "10px 0px", color: "#7A7A7A" }}>{userDetails.Name}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography
                      variant="caption"
                      display="block"
                      fontWeight={800}
                      fontSize={14}
                    >
                      {languageData.Key4}{" "}
                      <span className="customSpanAlert">*</span>
                    </Typography>
                    <Typography sx={{ padding: "10px 0px", color: "#7A7A7A" }}>{userDetails.JobTitle} </Typography>
                  </Grid>
                </Grid>
              )}
              {step.aggrement && (
                <Box sx={{ display: "flex", alignItems: "center", marginTop: "16px", backgroundColor: "#f2f2f2", padding: "20px" }}>
                  <CheckBoxControl
                    value={step.isChecked}
                    onChange={() => handleCheckboxChange(index)}
                  />
                  <Typography sx={{ fontSize: "12px", marginLeft: "8px" }}>
                    {step.aggrement}
                    <span className="customSpanAlert">*</span>
                  </Typography>
                </Box>
              )}
              <Box sx={{ mt: 2, ml: 2 }}>
                {index === 0 ? "" : (
                  <Button
                    disabled={index === 0 ? true : false}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1, p: 1, borderRadius: "20px", backgroundColor: "#e6e6e6", color: "#212129" }}
                  >
                    {languageData.Key28}
                  </Button>
                )}

                <Button
                  variant="contained"
                  onClick={() => {
                    if (activeStep === steps.length - 1) {
                      handleSubmit(stepValues);
                    } else {
                      handleNext();
                    }
                  }}
                  sx={{ mt: 1, mr: 1, p: 1, borderRadius: "20px", backgroundColor: "#212129", color: "white" }}
                  disabled={!isStepValid()}
                >
                  {activeStep === steps.length - 1 ? languageData.Key22 : languageData.Key8}
                </Button>
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  </Box>
)}
      <Spinner isLoading={inProgress} />
    </>
  );
};
export default Dashboard;

